import React from 'react';
import PropTypes from 'prop-types';

class Casengo extends React.PureComponent {
    componentDidMount() {
        this.generateScript();
    }

    generateUrl = () => {
        return '//mobian.casengo.com/apis/inline-widget.js?r=d363c66603a333a475a0b5f0a80691d6068ede54';
    };

    generateScript = () => {
        const url = this.generateUrl();
        const script = document.createElement('script');

        script.src = `${ url }`;
        script.type = 'text/javascript';
        document.getElementById('casengo-vipbtn');
        document.body.appendChild(script);
    }

    render() {
        const {
            className,
            ctype,
            group,
            id,
            labels,
            language,
            position,
            subdomain,
        } = this.props;

        return (
            <div
                className={ className }
                data-ctype={ ctype }
                data-group={ group }
                data-labels={ labels }
                data-language={ language }
                data-position={ position }
                data-subdomain={ subdomain }
                id={ id }
            />
        );
    }
}

Casengo.defaultProps = {
    className: 'casengo-vipbtn',
    ctype: 'inline',
    group: '39728',
    id: 'casengo-vipbtn',
    labels: 'Mobian',
    language: 'en_US',
    position: 'bottom-right',
    subdomain: 'Mobian',
};

Casengo.propTypes = {
    className: PropTypes.string,
    ctype: PropTypes.string,
    group: PropTypes.string,
    id: PropTypes.string,
    labels: PropTypes.string,
    language: PropTypes.string,
    position: PropTypes.string,
    subdomain: PropTypes.string,
};

export default Casengo;



// WEBPACK FOOTER //
// ./src/containers/Casengo/Casengo.js